import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMicrophone, faStop,faClock } from "@fortawesome/free-solid-svg-icons";
import RealTimeOscillator from "./RealTimeOscillator ";


const RecordingControls = ({
  recording,
  toggleRecording,
  voiceDuration,
  formatDuration,
  handleSaveAndGoHome,
  sentiment,
}) => {
  return (
    <main className="flex flex-col items-center justify-center space-y-12 mt-8">
<div className="flex flex-col items-center">
  {/* Button for recording */}
  <button
    onClick={toggleRecording}
    className={`flex items-center justify-center bg-custom-gradient text-white focus:outline-none focus:ring-2 focus:ring-offset-2 w-16 h-16 rounded-full shadow-lg transition-all duration-300 mb-8 hover:scale-110`}
  >
    <FontAwesomeIcon icon={recording ? faStop : faMicrophone} className="text-3xl" />
  </button>

  {/* Conditional text below the button */}
  <p className="text-lg font-semibold text-[#979797]">
    {recording ? 'Stop Recording' : 'Start Recording'}
  </p>
</div>


      {/* <p className="text-indigo-800 text-xl text-center mt-6 flex items-center justify-center">
        <FontAwesomeIcon icon={faClock} className="mr-2 text-indigo-500" />
        Duration of conversation:{" "}
        <span className="notranslate font-semibold ml-2">
          {formatDuration(voiceDuration)}
        </span>
      </p>
      <RealTimeOscillator sentiment={sentiment} /> */}

    </main>
  );
};

export default RecordingControls;
